import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapaSedes } from '@/components/MapaSedes';
import { GaleriaProyectos } from '@/components/GaleriaProyectos';

const API = process.env.REACT_APP_BACKEND_URL;

const WA = '50254307807';
const AZUL = '#1F8FE0';
const NAVY = '#0E2A47';
const waLink = (text) => `https://wa.me/${WA}?text=${encodeURIComponent(text)}`;
const LOGO = 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/a5w39i03_3fff9dc1-c12f-407d-a805-ccf2b53ccedc.jpeg';
const HERO = 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/04tun9op_c1b49a1c-6b79-4c8f-be77-3442db965c42.jpeg';
const ABOUT = 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/lkoq46hn_270d70bc-b4d7-4436-aa20-273deb8d2a81.jpeg';

const PRODUCTOS = [
  {
    slug: '/pasamanosaceroinox',
    tab: 'Pasamanos',
    nombre: 'Pasamanos de Acero Inoxidable',
    desc: 'Con vidrio templado. Diseño a la medida para escaleras, balcones y exteriores.',
    puntos: ['Acero inoxidable 304', 'Vidrio templado', 'Escaleras, balcones y exteriores'],
    img: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/lt9eqepc_dd45bcb8-5401-4fb5-9d40-23125cab0f97.jpeg',
    tag: 'Producto líder',
  },
  {
    slug: '/ventanasypuertaseuro',
    tab: 'Ventanas Euro',
    nombre: 'Ventanas y Puertas Línea Euro',
    desc: 'Aluminio europeo en 6 colores: gris, negro, blanco, bronce, inox e imitación madera.',
    puntos: ['Aluminio europeo', '6 colores disponibles', 'Abatibles y corredizas'],
    img: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/6409f7a14dce1bc8a567039caf207cd149e0eafcc676a6e92095a1b5ceb1cbc0.jpeg',
    tag: 'Nuevo',
  },
  {
    slug: '/fachadasvidriotemplado',
    tab: 'Fachadas',
    nombre: 'Fachadas de Vidrio Templado',
    desc: 'Vidrio de 10mm y 12mm con arañas y herrajes de acero inoxidable 304. Para comercios y residencias.',
    puntos: ['Vidrio 10mm y 12mm', 'Arañas inox 304', 'Claro, bronce y gris'],
    img: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/2tv4lhog_04936d63-007a-4228-815a-5a06da328a98.jpeg',
    tag: 'Comercios',
  },
  {
    slug: '/duchasymamparas',
    tab: 'Duchas',
    nombre: 'Bañeras, Duchas y Mamparas',
    desc: 'Corredizas y abatibles en vidrio templado de 6, 8 y 10mm. Claro, bronce, gris, film o sandblast.',
    puntos: ['Vidrio 6, 8 y 10mm', 'Herrajes cromados, satinados y negros', 'Film o sandblast'],
    img: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/2hu6rcej_6245a9c8-1654-45eb-8aa0-c44e265b2b1f.jpeg',
    tag: 'Baños',
  },
  {
    slug: '/techocurvo',
    tab: 'Techo Curvo',
    nombre: 'Techo Curvo',
    desc: 'Cubre bodegas, naves, canchas y salones sin columnas intermedias, con luz natural integrada.',
    puntos: ['Sin columnas intermedias', 'Grandes luces', 'Paneles traslúcidos curvos'],
    img: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/taark5ga_05a00ed9-a6d1-4567-9787-8661a7e2e063.jpeg',
    tag: 'Nuevo',
  },
  {
    slug: '/pvcpuertasyventanas',
    tab: 'PVC',
    nombre: 'Puertas y Ventanas de PVC',
    desc: 'PVC de calidad en blanco e imitación madera. No se oxida, casi no pide mantenimiento y con vidrio insulado logra máximo aislamiento.',
    puntos: ['Blanco e imitación madera', 'Corredizas, fijas, abatibles, proyectables y guillotina', 'Vidrio insulado termoacústico'],
    img: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/lkoq46hn_270d70bc-b4d7-4436-aa20-273deb8d2a81.jpeg',
    tag: 'Nuevo',
  },
  {
    slug: '/aceroinox',
    tab: 'Acero Inox',
    nombre: 'Trabajos de Acero Inoxidable',
    desc: 'Mamparas sanitarias, forros de elevadores, mesas y cualquier trabajo a la medida. Higiénico, fácil de limpiar y durable por décadas.',
    puntos: ['Láminas 201, 304 y 430', 'Construcción, alimenticia y médica', 'Fabricación propia a la medida'],
    img: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/rsygp8ts_a514dc3e-6ea5-49aa-bba7-fda2fb191965.jpeg',
    tag: 'Nuevo',
  },
];

const SEDES = [
  { nombre: 'Sede Central', dir: '14 Calle 8-00 zona 11, Colonia Mariscal, Guatemala', lat: 14.5942, lng: -90.5512, maps: '14 Calle 8-00 zona 11, Colonia Mariscal, Ciudad de Guatemala' },
  { nombre: 'Sede Xela', dir: '9 Calle 23-78 zona 7, frente a Maxi Despensa del periférico', lat: 14.8555, lng: -91.5387, maps: '9 Calle 23-78 zona 7, Quetzaltenango' },
  { nombre: 'Sede Huehuetenango', dir: '09 Calle 10-56 zona 1', lat: 15.3172, lng: -91.4711, maps: '9 Calle 10-56 zona 1, Huehuetenango' },
  { nombre: 'Sede Chichicastenango', dir: '7ma calle 5-32 Zona 1, interior del Comercial Hermo Vista Mall, Local 5-06', lat: 14.9436, lng: -91.1109, maps: '7a calle 5-32 zona 1, Chichicastenango' },
  { nombre: 'Sede Chiquimula', dir: '12 Avenida entre la 5ta y 6ta calle', lat: 14.7995, lng: -89.5449, maps: '12 Avenida entre 5ta y 6ta calle, Chiquimula' },
  { nombre: 'Sede El Salvador', dir: '', lat: 13.6929, lng: -89.2182, maps: 'El Salvador' },
];

const NAV = [
  ['#inicio', 'Inicio'],
  ['#productos', 'Productos'],
  ['#galeria', 'Galería'],
  ['#nosotros', 'Quiénes somos'],
  ['#sedes', 'Sedes'],
  ['#contacto', 'Contacto'],
];

const FEATURES = [
  ['Fabricación a la medida', 'Cada proyecto se diseña y fabrica según tus medidas y estilo.',
    <path key="f1" d="M22 9L12 2 2 9v13h7v-8h6v8h7V9z" />],
  ['Materiales de calidad', 'Inox 304, vidrio templado certificado y aluminio europeo.',
    <path key="f2" d="M12 2l8 4v6c0 5-3.4 9-8 10-4.6-1-8-5-8-10V6l8-4zm-1.2 13.4l6-6-1.4-1.4-4.6 4.6-2-2-1.4 1.4 3.4 3.4z" />],
  ['Instalación profesional', 'Nuestro propio equipo instala de principio a fin.',
    <path key="f3" d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1 .1-1.4z" />],
  ['Asesoría sin costo', 'Te visitamos, medimos y cotizamos gratis, sin compromiso.',
    <path key="f4" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-9 11H9v-2h2v2zm0-4H9V5h2v4zm4 4h-2v-2h2v2zm0-4h-2V5h2v4z" />],
];

export default function CatalogoSoluciones() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const [portada, setPortada] = useState(null);
  const [bannerIdx, setBannerIdx] = useState(0);
  const p = PRODUCTOS[tab];
  const banners = portada?.banners || [];
  const ofertas = portada?.ofertas || [];
  const navItems = ofertas.length ? [NAV[0], NAV[1], ['#ofertas', 'Ofertas'], ...NAV.slice(2)] : NAV;

  useEffect(() => {
    fetch(`${API}/api/landing/soluciones/portada`).then((r) => r.json()).then(setPortada).catch(() => {});
  }, []);

  useEffect(() => {
    if (banners.length < 2) return;
    const t = setInterval(() => setBannerIdx((i) => (i + 1) % banners.length), 5000);
    return () => clearInterval(t);
  }, [banners.length]);

  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif", color: '#1B2B3A' }} className="min-h-screen bg-white scroll-smooth">
      {/* Top bar navy */}
      <div style={{ background: NAVY }} className="text-white/85 text-xs">
        <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
          <p className="font-bold flex items-center gap-1.5">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>
            Guatemala 🇬🇹 y El Salvador 🇸🇻
          </p>
          <a href={waLink('¡Hola! Quiero información de sus productos 😊')} target="_blank" rel="noreferrer" className="font-bold hover:text-white transition-colors flex items-center gap-1.5">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.3 0 .7-.2 1l-2.3 2.2z"/></svg>
            WhatsApp 5430-7807
          </a>
        </div>
      </div>

      {/* Header blanco */}
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-slate-200 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-between gap-3">
          <a href="#inicio" className="flex items-center gap-3 shrink-0">
            <img src={LOGO} alt="Soluciones Arquitectónicas" className="h-10 w-auto" data-testid="hub-logo" />
            <p className="hidden md:block text-[10px] text-slate-400 tracking-[0.25em] uppercase border-l border-slate-200 pl-3 font-bold">Modernizando ambientes</p>
          </a>
          <nav className="hidden lg:flex items-center gap-6">
            {navItems.map(([href, label]) => (
              <a key={href} href={href} className="text-sm font-bold text-slate-600 hover:text-[#1F8FE0] transition-colors">{label}</a>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <a href={waLink('¡Hola! Quiero una cotización 😊')} target="_blank" rel="noreferrer" data-testid="hub-wa-header"
              style={{ background: AZUL }}
              className="hover:brightness-110 text-white text-sm font-black px-5 py-2 rounded-md transition-all">
              COTIZAR
            </a>
            <button onClick={() => setMenuOpen((v) => !v)} data-testid="hub-hamburger-btn" aria-label="Menú"
              className="lg:hidden flex flex-col justify-center items-center gap-[5px] w-10 h-10 rounded-lg border border-slate-300 hover:border-slate-500 transition-colors">
              <span className={`block w-5 h-0.5 bg-slate-700 transition-transform ${menuOpen ? 'rotate-45 translate-y-[7px]' : ''}`} />
              <span className={`block w-5 h-0.5 bg-slate-700 transition-opacity ${menuOpen ? 'opacity-0' : ''}`} />
              <span className={`block w-5 h-0.5 bg-slate-700 transition-transform ${menuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`} />
            </button>
          </div>
        </div>
        {menuOpen && (
          <nav className="lg:hidden border-t border-slate-200 bg-white px-4 py-3 space-y-1 shadow-lg" data-testid="hub-mobile-menu">
            {navItems.map(([href, label]) => (
              <a key={href} href={href} onClick={() => setMenuOpen(false)}
                className="block px-3 py-2.5 rounded-lg text-sm font-bold text-slate-700 hover:bg-slate-50 transition-colors">{label}</a>
            ))}
            <div className="border-t border-slate-200 pt-2 mt-2">
              <p className="px-3 pb-1 text-[10px] uppercase tracking-widest text-slate-400 font-bold">Productos</p>
              {PRODUCTOS.map((pr) => (
                <Link key={pr.slug} to={pr.slug} onClick={() => setMenuOpen(false)}
                  className="block px-3 py-2 rounded-lg text-sm font-bold text-[#1F8FE0] hover:bg-slate-50 transition-colors">{pr.nombre}</Link>
              ))}
            </div>
          </nav>
        )}
      </header>

      {/* Banners subidos desde el CRM (imagen completa ajustada al área) */}
      {banners.length > 0 && (
        <section className="relative overflow-hidden" style={{ background: NAVY }} data-testid="soluciones-banners">
          <img src={banners[bannerIdx]?.url} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover blur-2xl scale-110 opacity-40" />
          <div className="relative max-w-6xl mx-auto">
            <img src={banners[bannerIdx]?.url} alt={banners[bannerIdx]?.titulo || 'Banner'} data-testid="soluciones-banner-img"
              className="w-full max-h-64 sm:max-h-96 object-contain mx-auto" />
            {banners[bannerIdx]?.titulo && (
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/75 to-transparent px-4 py-3">
                <p className="text-white text-sm sm:text-lg font-black">{banners[bannerIdx].titulo}</p>
              </div>
            )}
            {banners.length > 1 && (
              <div className="absolute bottom-2.5 right-3 flex gap-1.5">
                {banners.map((_, i) => (
                  <button key={i} onClick={() => setBannerIdx(i)} aria-label={`Banner ${i + 1}`}
                    className={`w-2 h-2 rounded-full transition-colors ${i === bannerIdx ? 'bg-white' : 'bg-white/40'}`} />
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {/* Hero */}
      <section id="inicio" className="relative">
        <img src={HERO} alt="Fachada de vidrio templado" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(10,32,56,0.92) 0%, rgba(10,32,56,0.72) 45%, rgba(10,32,56,0.35) 100%)' }} />
        <div className="relative max-w-6xl mx-auto px-4 pt-20 pb-32">
          <p className="text-white/80 font-bold text-sm mb-3 flex items-center gap-2">
            <span style={{ background: AZUL }} className="w-8 h-0.5 inline-block" />+18 Años de Experiencia
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.08] max-w-2xl text-white">
            Modernizando <span style={{ color: '#5BC0FF' }}>ambientes</span> en Guatemala y El Salvador
          </h1>
          <p className="text-white/75 text-base mt-5 max-w-xl" data-testid="hub-descripcion">
            Fabricamos e instalamos a la medida: pasamanos de acero inoxidable, ventanas y puertas de aluminio europeo, puertas y ventanas de PVC, fachadas de vidrio templado, duchas y mamparas, y techos curvos. Con nuestro propio equipo de profesionales, de principio a fin.
          </p>
          <div className="flex gap-3 mt-7 flex-wrap">
            <a href="#productos" style={{ background: AZUL }}
              className="hover:brightness-110 text-white font-black px-7 py-3.5 rounded-md text-sm transition-all shadow-lg">
              VER PRODUCTOS →
            </a>
            <a href={waLink('¡Hola! Quiero información de sus productos 😊')} target="_blank" rel="noreferrer"
              className="bg-white/10 backdrop-blur border border-white/40 hover:bg-white hover:text-[#0E2A47] text-white font-bold px-7 py-3.5 rounded-md text-sm transition-colors">
              Hablar con un asesor
            </a>
          </div>
        </div>
      </section>

      {/* Feature cards flotantes */}
      <section className="max-w-6xl mx-auto px-4 -mt-16 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {FEATURES.map(([t, d, icon], i) => (
            <div key={t} className="bg-white rounded-xl shadow-xl border border-slate-100 p-6 text-center hover:-translate-y-1 transition-transform" data-testid={`feature-${i}`}>
              <div className="w-14 h-14 mx-auto rounded-full flex items-center justify-center mb-3" style={{ background: '#E8F3FC' }}>
                <svg width="26" height="26" viewBox="0 0 24 24" fill={AZUL}>{icon}</svg>
              </div>
              <p className="font-black text-sm" style={{ color: NAVY }}>{t}</p>
              <p className="text-slate-500 text-xs mt-1.5 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* About */}
      <section id="nosotros" className="max-w-6xl mx-auto px-4 py-16 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="relative">
          <figure className="rounded-2xl overflow-hidden shadow-2xl">
            <img src={ABOUT} alt="Proyecto de ventanería instalado por Soluciones Arquitectónicas" className="w-full h-[380px] object-cover" />
          </figure>
          <div style={{ background: AZUL }} className="absolute -bottom-6 -right-2 sm:right-6 w-28 h-28 rounded-full flex flex-col items-center justify-center text-white shadow-xl border-4 border-white">
            <p className="text-2xl font-black leading-none">+18</p>
            <p className="text-[10px] font-bold text-center leading-tight mt-1">años de<br/>experiencia</p>
          </div>
        </div>
        <div>
          <p style={{ color: AZUL }} className="font-black text-xs tracking-[0.25em] uppercase mb-2 flex items-center gap-2">
            <span style={{ background: AZUL }} className="w-6 h-0.5 inline-block" />Quiénes somos
          </p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight" style={{ color: NAVY }}>
            Somos profesionales en fabricación e instalación <span style={{ color: AZUL }}>a la medida</span>
          </h2>
          <p className="text-slate-500 text-base mt-4">
            Somos una empresa guatemalteca del Grupo SACH. Atendemos hogares, comercios e industria en toda Guatemala y El Salvador con materiales de primera y nuestro propio equipo de instalación.
          </p>
          <div className="space-y-2.5 mt-5">
            {['Medición, fabricación e instalación de principio a fin', 'Materiales certificados: inox 304, vidrio templado y aluminio europeo', 'Manuales de mantenimiento y servicio postventa'].map((c) => (
              <p key={c} className="flex items-start gap-2.5 text-sm font-bold text-slate-700">
                <svg width="18" height="18" viewBox="0 0 24 24" fill={AZUL} className="shrink-0 mt-0.5"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 14.4l-4-4 1.4-1.4 2.6 2.6 5.8-5.8 1.4 1.4-7.2 7.2z"/></svg>
                {c}
              </p>
            ))}
          </div>
          <a href={waLink('¡Hola! Quiero información de sus productos 😊')} target="_blank" rel="noreferrer"
            style={{ background: AZUL }}
            className="inline-block mt-6 hover:brightness-110 text-white font-black px-7 py-3 rounded-md text-sm transition-all shadow-md">
            HABLEMOS DE TU PROYECTO →
          </a>
        </div>
      </section>

      {/* Productos con pestañas */}
      <section id="productos" style={{ background: '#F1F6FB' }}>
        <div className="max-w-6xl mx-auto px-4 py-16">
          <p style={{ color: AZUL }} className="font-black text-xs tracking-[0.25em] uppercase mb-2 text-center">Nuestro catálogo</p>
          <h2 className="text-2xl sm:text-3xl font-black text-center mb-8" style={{ color: NAVY }}>
            Explora por <span style={{ color: AZUL }}>producto</span>
          </h2>
          <div className="flex gap-2 overflow-x-auto pb-2 justify-start sm:justify-center" data-testid="hub-tabs">
            {PRODUCTOS.map((pr, i) => (
              <button key={pr.slug} onClick={() => setTab(i)} data-testid={`hub-tab-${i}`}
                className={`shrink-0 text-sm font-black px-5 py-2.5 rounded-md border transition-colors ${tab === i ? 'text-white border-transparent shadow-md' : 'bg-white border-slate-200 text-slate-500 hover:text-slate-800 hover:border-slate-400'}`}
                style={tab === i ? { background: AZUL } : {}}>
                {pr.tab}
              </button>
            ))}
          </div>
          <div className="mt-5 bg-white rounded-2xl overflow-hidden grid grid-cols-1 md:grid-cols-2 shadow-xl border border-slate-100" data-testid="hub-tab-panel">
            <div className="relative">
              <img src={p.img} alt={p.nombre} className="w-full h-64 md:h-full object-cover" />
              <span style={{ background: AZUL }} className="absolute top-3 left-3 text-white text-[10px] font-black px-3 py-1 rounded-md uppercase tracking-wide shadow">{p.tag}</span>
            </div>
            <div className="p-6 sm:p-8 flex flex-col">
              <h3 className="font-black text-2xl leading-tight" style={{ color: NAVY }}>{p.nombre}</h3>
              <p className="text-slate-500 text-sm mt-3">{p.desc}</p>
              <div className="space-y-2 mt-4">
                {p.puntos.map((pt) => (
                  <p key={pt} className="flex items-center gap-2 text-sm font-bold text-slate-700">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill={AZUL}><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 14.4l-4-4 1.4-1.4 2.6 2.6 5.8-5.8 1.4 1.4-7.2 7.2z"/></svg>
                    {pt}
                  </p>
                ))}
              </div>
              <div className="flex gap-3 mt-6 flex-wrap">
                <Link to={p.slug} data-testid="hub-tab-ver-producto"
                  style={{ background: AZUL }}
                  className="hover:brightness-110 text-white font-black px-5 py-2.5 rounded-md text-xs transition-all shadow-md">
                  VER PÁGINA Y COTIZAR →
                </Link>
                <a href={waLink(`¡Hola! Quiero información de ${p.nombre} 😊`)} target="_blank" rel="noreferrer"
                  className="border border-slate-300 hover:border-[#1F8FE0] hover:text-[#1F8FE0] text-slate-600 font-bold px-5 py-2.5 rounded-md text-xs transition-colors">
                  Cotizar por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ofertas y descuentos */}
      {ofertas.length > 0 && (
        <section id="ofertas" className="max-w-6xl mx-auto px-4 py-16" data-testid="soluciones-ofertas">
          <p className="font-black text-xs tracking-[0.25em] uppercase mb-2 text-center" style={{ color: '#E0342F' }}>Aprovecha ahora</p>
          <h2 className="text-2xl sm:text-3xl font-black text-center mb-8" style={{ color: NAVY }}>
            Ofertas y <span style={{ color: '#E0342F' }}>descuentos</span>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {ofertas.map((o) => (
              <div key={o.id} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-1 transition-all" data-testid={`soluciones-oferta-${o.id}`}>
                <div className="bg-slate-50 flex items-center justify-center">
                  <img src={o.url} alt={o.titulo || 'Oferta'} loading="lazy" className="w-full max-h-72 object-contain" />
                </div>
                <div className="p-4 flex items-center justify-between gap-3">
                  <p className="font-black text-sm leading-tight" style={{ color: NAVY }}>{o.titulo || 'Oferta especial'}</p>
                  <a href={waLink(`¡Hola! Me interesa la oferta${o.titulo ? `: ${o.titulo}` : ' que vi en su página'} 😊`)}
                    target="_blank" rel="noreferrer" data-testid={`soluciones-oferta-wa-${o.id}`}
                    className="shrink-0 text-white text-xs font-black px-4 py-2 rounded-md hover:brightness-110 transition-all" style={{ background: '#25D366' }}>
                    ME INTERESA
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Sedes */}
      <section id="sedes" className="max-w-6xl mx-auto px-4 py-16">
        <p style={{ color: AZUL }} className="font-black text-xs tracking-[0.25em] uppercase mb-2 text-center">Nuestras sedes</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8" style={{ color: NAVY }}>Cerca de <span style={{ color: AZUL }}>ti</span></h2>
        <MapaSedes sedes={SEDES} />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-5" data-testid="hub-sedes">
          {SEDES.map((s) => (
            <div key={s.nombre} className="bg-white border border-slate-200 rounded-xl p-5 flex gap-3 shadow-sm hover:shadow-md transition-shadow" data-testid={`sede-${s.nombre.toLowerCase().replace(/ /g, '-')}`}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill={AZUL} className="shrink-0 mt-0.5"><path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>
              <div>
                <p className="font-black text-sm" style={{ color: NAVY }}>{s.nombre}</p>
                {s.dir ? <p className="text-slate-500 text-sm mt-1 leading-relaxed">{s.dir}</p> : null}
                <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(s.maps)}`}
                  target="_blank" rel="noreferrer" data-testid={`como-llegar-${s.nombre.toLowerCase().replace(/ /g, '-')}`}
                  style={{ color: AZUL, borderColor: AZUL }}
                  className="inline-block mt-2.5 border hover:bg-[#1F8FE0] hover:!text-white font-black px-4 py-1.5 rounded-md text-[11px] transition-colors">
                  Cómo llegar →
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <GaleriaProyectos />

      {/* Contacto */}
      <section id="contacto" style={{ background: NAVY }}>
        <div className="max-w-6xl mx-auto px-4 py-14 text-white">
          <p style={{ color: '#5BC0FF' }} className="font-black text-xs tracking-[0.25em] uppercase mb-2">Contacto</p>
          <h2 className="text-2xl sm:text-3xl font-black mb-8">Hablemos de tu <span style={{ color: '#5BC0FF' }}>proyecto</span></h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div>
              <p style={{ color: '#5BC0FF' }} className="font-black text-xs uppercase tracking-widest mb-2">WhatsApp</p>
              <a href={waLink('¡Hola! Quiero información de sus productos 😊')} target="_blank" rel="noreferrer"
                data-testid="hub-contacto-wa" className="text-white/85 hover:text-white font-bold transition-colors">+502 5430 7807</a>
            </div>
            <div>
              <p style={{ color: '#5BC0FF' }} className="font-black text-xs uppercase tracking-widest mb-2">Teléfono</p>
              <a href="tel:+50254307807" className="text-white/85 hover:text-white font-bold transition-colors">5430-7807</a>
            </div>
            <div>
              <p style={{ color: '#5BC0FF' }} className="font-black text-xs uppercase tracking-widest mb-2">Cobertura</p>
              <p className="text-white/85 font-bold">Guatemala 🇬🇹 y El Salvador 🇸🇻</p>
            </div>
          </div>
        </div>
        <footer className="border-t border-white/10 py-5 text-center text-xs text-white/40">
          Soluciones Arquitectónicas · Modernizando ambientes · Grupo SACH
        </footer>
      </section>

      {/* WhatsApp flotante */}
      <a href={waLink('¡Hola! Vi el catálogo de Soluciones Arquitectónicas y quiero información 😊')}
        target="_blank" rel="noreferrer" data-testid="hub-wa-float" aria-label="WhatsApp"
        className="fixed bottom-5 right-5 z-50 bg-[#25D366] hover:scale-110 transition-transform w-14 h-14 rounded-full flex items-center justify-center shadow-2xl">
        <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.7 6L4 29l8.2-1.6c1.2.6 2.5.9 3.8.9 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 22c-1.2 0-2.4-.3-3.5-.8l-.6-.3-4.9 1 1-4.7-.3-.6C6.6 18.1 6 16.6 6 15 6 9.5 10.5 5 16 5s10 4.5 10 10-4.5 10-10 10zm5.5-7.5c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.4z"/></svg>
      </a>
    </div>
  );
}
